import { lazy } from 'react'

export const ChangeClientStatusModalAsync = lazy(() =>
	import('./ChangeClientStatusModal').then((module) => ({
		default: module.ChangeClientStatusModal
	}))
)
